document.addEventListener(
    "DOMContentLoaded", () => {
        let header = document.querySelector('#header');
        let navbarTop = document.querySelector("#mmenuContents .navbar-top-content");
        let backbtn = document.querySelector('#mmenuContents .menu-back').innerHTML;

        // Initialize sticky header
        new Mhead( "#header", {
            hide: header.dataset.mheadHide ?? 100
        });

        // Initialize navigation
        new Mmenu( "#mainNavigation", {
            "offCanvas": {
                "position": "right-front"
            },
            "theme": "white-contrast",
            "navbars": [
                {
                    "position": "top",
                    "content": [
                        (navbarTop) ? navbarTop.outerHTML : '',
                        "prev",
                    ]
                }
            ],
        });

        mmenuBackBtns = document.querySelectorAll('#mainNavigation .mm-btn--prev');
        mmenuBackBtns.forEach((btn) => {
            btn.innerHTML = backbtn;
        })
    }
);